/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { ForgotPassword } from './components/ForgotPassword';
import { ConfirmPassword } from './components/ConfirmPassword';
import { Login } from './components/Login';
import { toAbsoluteUrl } from '../../../_mexablock/helpers';
import Lottie from 'lottie-react';
import animationData from '../../../_mexablock/assets/json/animation_llps1y53.json';
import animation from '../../../_mexablock/assets/json/animation_llpto72j.json';
// import { Seo } from '../../../SEO/Seo';

export function AuthPage() {
  useEffect(() => {
    document.body.classList.add('bg-white');
    return () => {
      document.body.classList.remove('bg-white');
    };
  }, []);

  return (
    <>
      <div
        className="d-flex flex-column flex-md-row w-100 h-100"
        style={{
          backgroundImage: `url(${toAbsoluteUrl(
            '/media/illustrations/sketchy-1/bg-inicio-de-sesion.jpg'
          )})`,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
        }}
      >
        {/* Columna izquierda (oculta en celular) */}
        <div className="flex-column d-none d-md-flex w-50">
          <div
            className="w-400px"
            style={{
              left: 0,
              bottom: 0,
              position: 'absolute',
            }}
          >
            {/* <Lottie animationData={animationData} /> */}
          </div>
        </div>

        {/* Columna central (100% en celular, auto en desktop) */}
        <div className="flex-column w-100 w-md-auto">
          <div className="d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20 mt-20">
            <a href="#" className="mb-10">
              <img
                alt="Logo"
                src={toAbsoluteUrl('/media/logos/logo-mty-movil-blanco.png')}
                className="h-100px"
              />
            </a>
            <div className="w-100 w-lg-500px bg-white rounded shadow-sm p-10 p-lg-15 mx-auto">
              <Switch>
                <Route path="/auth/login" component={Login} />
                <Route
                  path="/auth/confirm-password/:token"
                  component={ConfirmPassword}
                />
                <Route
                  path="/auth/forgot-password"
                  component={ForgotPassword}
                />
                <Redirect from="/auth" exact={true} to="/auth/login" />
                <Redirect to="/auth/login" />
              </Switch>
            </div>
            <a href="#" className="d-block text-center mt-8">
              <img
                alt="Logo"
                src={toAbsoluteUrl('/media/logos/logo-by-softcell.png')}
                className="img-fluid"
                style={{ maxHeight: '60px', width: 'auto' }}
              />
            </a>
          </div>
        </div>

        {/* Columna derecha (oculta en celular) */}
        <div
          className="flex-column d-none d-md-flex w-50"
          style={{ position: 'relative' }}
        >
          <div
            className="w-350px"
            style={{
              right: 0,
              bottom: 0,
              position: 'absolute',
            }}
          >
            {/* <Lottie animationData={animation} /> */}
          </div>
        </div>
      </div>
    </>
  );
}
